<template>
  <div class="legal-page">
    <header class="legal-header">
      <div class="header-container">
        <router-link to="/" class="logo-link">
          <img src="/landing/logo-white.svg" :alt="$t('legacy.Макетта')" class="logo" />
        </router-link>
        <router-link to="/" class="back-link">← {{ $t('legacy.На главную') }}</router-link>
      </div>
    </header>

    <main class="legal-content">
      <h1>{{ $t('legacy.Контакты и реквизиты') }}</h1>

      <section class="contact-section">
        <h2>{{ $t('legacy.Связаться с нами') }}</h2>
        <p>{{ $t('Мы всегда рады помочь вам с любыми вопросами по использованию сервиса Макетта.') }}</p>
        
        <div class="contact-grid">
          <div class="contact-card">
            <div class="contact-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <polyline points="22,6 12,13 2,6" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>Email</h3>
            <p class="contact-value">maketta.pro@mail.ru</p>
            <p class="contact-note">{{ $t('legacy.Ответим в течение 24 часов') }}</p>
          </div>
          
          <div class="contact-card">
            <div class="contact-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93v6.14C2 20.67 3.33 22 8.93 22h6.14C20.67 22 22 20.67 22 15.07V8.93C22 3.33 20.67 2 15.07 2zm3.48 8.56h-1.89c-.71 0-.85.33-.85.68 0 .63.84 1.56.84 2.5 0 1.98-1.64 3.26-3.57 3.26-2.08 0-4.08-1.1-4.08-3.26 0-.94.84-1.87.84-2.5 0-.35-.14-.68-.85-.68H7.45C6.93 10.56 6.75 10.8 6.75 11.34c0 2.36 2.71 5.32 6.63 5.32 3.46 0 5.84-1.89 5.84-5.32 0-.5-.19-.78-.67-.78z" fill="#6366f1"/>
              </svg>
            </div>
            <h3>{{ $t('legacy.ВКонтакте') }}</h3>
            <a href="https://vk.ru/makettapro" target="_blank" class="contact-value contact-value-link">vk.ru/makettapro</a>
            <p class="contact-note">{{ $t('legacy.Группа сервиса') }}</p>
          </div>
        </div>
      </section>

      <section class="info-section">
        <h2>{{ $t('О сервисе Макетта') }}</h2>
        <p>{{ $t('Макетта — это онлайн-конструктор проектов для декораторов и ивент-специалистов. Наш сервис помогает создавать профессиональные визуализации оформления мероприятий, автоматически рассчитывать сметы и производить впечатление на клиентов.') }}</p>
        
        <div class="service-features">
          <h3>{{ $t('Что вы получаете:') }}</h3>
          <ul>
            <li><strong>{{ $t('Библиотека элементов декора') }}</strong>{{ $t(' — сотни готовых элементов: арки, шары, цветочные композиции, текстиль, свечи и многое другое') }}</li>
            <li><strong>{{ $t('Интуитивный редактор') }}</strong>{{ $t(' — создавайте проекты прямо в браузере, без установки программ') }}</li>
            <li><strong>{{ $t('Автоматический расчёт сметы') }}</strong>{{ $t(' — назначьте цены на элементы и получайте стоимость проекта в реальном времени') }}</li>
            <li><strong>{{ $t('Экспорт в PDF и Excel') }}</strong>{{ $t(' — формируйте профессиональные документы для клиентов') }}</li>
            <li><strong>{{ $t('AI-визуализация') }}</strong>{{ $t(' — превращайте эскизы в фотореалистичные изображения') }}</li>
            <li><strong>{{ $t('Мобильная версия') }}</strong>{{ $t(' — работайте с проектами на телефоне или планшете') }}</li>
          </ul>
        </div>
      </section>

      <section class="info-section">
        <h2>{{ $t('legacy.Как получить доступ к сервису') }}</h2>
        <p>{{ $t('После оплаты подписки доступ к полному функционалу сервиса предоставляется автоматически. Вы сможете пользоваться всеми возможностями выбранного тарифа сразу после поступления платежа.') }}</p>
        <ol>
          <li>{{ $t('Зарегистрируйтесь на сайте maketta.pro') }}</li>
          <li>{{ $t('Выберите подходящий тарифный план') }}</li>
          <li>{{ $t('legacy.Оплатите подписку банковской картой') }}</li>
          <li>{{ $t('legacy.Получите мгновенный доступ к функционалу') }}</li>
        </ol>
      </section>

      <section class="requisites-section">
        <h2>{{ $t('legacy.Реквизиты') }}</h2>
        <div class="requisites-card">
          <div class="requisites-row">
            <span class="requisites-label">{{ $t('legacy.Наименование:') }}</span>
            <span class="requisites-value">ИП Немыкина Екатерина Сергеевна</span>
          </div>
          <div class="requisites-row">
            <span class="requisites-label">{{ $t('ОГРНИП:') }}</span>
            <span class="requisites-value">325547600094265</span>
          </div>
          <div class="requisites-row">
            <span class="requisites-label">{{ $t('ИНН:') }}</span>
            <span class="requisites-value">421717178949</span>
          </div>
          <div class="requisites-row">
            <span class="requisites-label">{{ $t('Email:') }}</span>
            <span class="requisites-value">maketta.pro@mail.ru</span>
          </div>
          <div class="requisites-row">
            <span class="requisites-label">{{ $t('legacy.Сайт:') }}</span>
            <span class="requisites-value">https://maketta.pro</span>
          </div>
        </div>
      </section>

      <section class="legal-links">
        <h2>{{ $t('legacy.Документы') }}</h2>
        <div class="links-grid">
          <router-link to="/terms" class="doc-link">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="14 2 14 8 20 8" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t('legacy.Публичная оферта') }}
          </router-link>
          <router-link to="/refund-policy" class="doc-link">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="14 2 14 8 20 8" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t('legacy.Политика возврата') }}
          </router-link>
        </div>
      </section>
    </main>

    <footer class="legal-footer">
      <p>© 2025 — {{ currentYear }} {{ $t('legacy.Макетта') }}. {{ $t('Все права защищены.') }}</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ContactsPage',
  data() {
    return { currentYear: new Date().getFullYear() }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.legal-header {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 20px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  height: 36px;
  width: 99px;
  object-fit: contain;
}

.back-link {
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  opacity: 0.9;
  transition: opacity 0.2s;
}

.back-link:hover {
  opacity: 1;
}

.legal-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

h1 {
  font-size: 32px;
  color: #1a1a2e;
  margin-bottom: 30px;
}

.contact-section,
.info-section,
.requisites-section,
.legal-links {
  margin-bottom: 40px;
}

h2 {
  font-size: 22px;
  color: #1a1a2e;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

p {
  color: #444;
  line-height: 1.7;
  margin-bottom: 15px;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.contact-card {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #e0e0e0;
  transition: transform 0.2s, box-shadow 0.2s;
}

.contact-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.contact-icon {
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  box-shadow: 0 2px 8px rgba(99,102,241,0.15);
}

.contact-card h3 {
  font-size: 16px;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.contact-value {
  font-size: 18px;
  font-weight: 600;
  color: #6366f1;
  margin-bottom: 5px !important;
}

.contact-note {
  font-size: 13px;
  color: #888;
  margin-bottom: 0 !important;
}

.contact-value-link {
  font-size: 18px;
  font-weight: 600;
  color: #6366f1;
  text-decoration: none;
  display: block;
  margin-bottom: 5px;
}

.contact-value-link:hover {
  text-decoration: underline;
}

.service-features {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 12px;
  margin-top: 20px;
}

.service-features h3 {
  font-size: 18px;
  color: #1a1a2e;
  margin-bottom: 15px;
}

.service-features ul {
  margin: 0;
  padding-left: 20px;
}

.service-features li {
  color: #444;
  line-height: 1.7;
  margin-bottom: 10px;
}

ol {
  margin: 15px 0;
  padding-left: 20px;
}

ol li {
  color: #444;
  line-height: 1.7;
  margin-bottom: 8px;
}

.requisites-card {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
}

.requisites-row {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.requisites-row:last-child {
  border-bottom: none;
}

.requisites-label {
  width: 140px;
  color: #666;
  flex-shrink: 0;
}

.requisites-value {
  color: #1a1a2e;
  font-weight: 500;
}

.links-grid {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.doc-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 25px;
  background: #f8f9fa;
  border-radius: 8px;
  text-decoration: none;
  color: #1a1a2e;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  transition: all 0.2s;
}

.doc-link:hover {
  background: #6366f1;
  color: #fff;
  border-color: #6366f1;
}

.doc-link:hover svg path,
.doc-link:hover svg polyline {
  stroke: #fff;
}

.legal-footer {
  text-align: center;
  padding: 30px;
  color: #666;
}

@media (max-width: 768px) {
  h1 {
    font-size: 24px;
  }
  
  .legal-content {
    padding: 20px 15px;
  }
  
  .contact-grid {
    grid-template-columns: 1fr;
  }
  
  .requisites-row {
    flex-direction: column;
  }
  
  .requisites-label {
    width: 100%;
    margin-bottom: 5px;
  }
}
</style>
